import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Breakpoint, useTheme } from "@mui/material/styles";
import { Box, Grid, Paper, Typography } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useTranslation } from "react-i18next";

interface ResponsiveDialogProps {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

const SignInResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  children,
  open,
  handleClose,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation("ResponsiveDialog");

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      maxWidth="md" // try: "sm" | "md" | "lg" | "xl"
      fullWidth
      aria-labelledby="responsive-dialog-title"
      PaperComponent={(props) => (
        <Paper
          {...props}
          sx={{ borderRadius: "30px", padding: "0px", overflow: "hidden" }}
        />
      )}
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          display: "flex",
          alignSelf: "end",
          position: "absolute",
          padding: 0,
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "400",
          color: "#a5a5a5",
          top: "16px",
          right: "26px",
          zIndex: 1,
        }}
      >
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon
            style={{ color: "#000", fontSize: "30px", fontWeight: "300" }}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default SignInResponsiveDialog;
